import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EnrolledUserItem } from "../types";

interface UsePreEnrolledUsersListArgs {
  corporateId: string | number;
  objectId: number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

const PRE_ENROLLED_STATUS = "PW,PA,R";

export const usePreEnrolledUsersList = ({
  corporateId,
  objectId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UsePreEnrolledUsersListArgs): PaginatedListResult<EnrolledUserItem> => {
  const url = corporateId
    ? `${ServicesURL.getEnrollment}?corporateId=${corporateId}&objectId=${objectId}`
    : null;

  return usePaginatedList<EnrolledUserItem>(
    url,
    {
      page,
      pageSize,
      search,
      fieldFilters: { status: PRE_ENROLLED_STATUS, ...(fieldFilters || {}) },
    },
    {
      responseKey: "enrollmentResponses",
      totalElementsKey: "totalElements",
      totalPagesKey: "totalPages",
    },
  );
};
